import { Button, Card, Elevation, FormGroup, HTMLSelect, InputGroup, TextArea } from "@blueprintjs/core";
import fetch from "node-fetch";
import React from 'react';
import { withRouter } from 'react-router-dom';
import numberUtils from "./../../../utils/number";

class PartyDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      ownerPost: false,
      tenantPost: false,
      propertyPost: false,
      occupationList: [],
      areaUidList: [],
      values: {
        owner: {
          name: '',
          age: '',
          gender: '',
          occupation: '',
          mobile: '',
          email: '',
          panNumber: '',
          aadhaarNumber: '',
          permanentAddress: '',
        },
        tenant: {
          name: '',
          age: '',
          gender: '',
          occupation: '',
          mobile: '',
          email: '',
          panNumber: '',
          aadhaarNumber: '',
          permanentAddress: '',
        },
        property: {
          areaUid: '',
          builtupArea: '',
          propertyType: '',
          bedroomCount: '',
          bathroomCount: '',
          propertyNumber: '',
          floorNumber: '',
          buildingName: '',
          pincode: '',
          furnitureAndFixtures: ''
        }
      },
      formValidate: {
        "owner-name": "required",
        "owner-age": "required",
        "owner-gender": "required",
        "owner-mobile": "required mobile",
        "owner-panNumber": "required pan",
        "owner-permanentAddress": "required",
        "tenant-name": "required",
        "tenant-age": "required",
        "tenant-gender": "required",
        "tenant-mobile": "required mobile",
        "tenant-panNumber": "required pan",
        "tenant-permanentAddress": "required",
        "property-areaUid": "required",
        "property-builtupArea": "required",
        "property-propertyType": "required",
        "property-pincode": "pin"
      },
      formErrorMsg: {}
    }
  }

  componentWillMount() {
    this.fetchAreaUid();
    this.fetchOccupation();
    this.fetchPartyDetails();
    this.fetchPropertyDetails();
  }

  componentDidUpdate() {
    // if (this.state.ownerPost && this.state.tenantPost) {
    //   this.props.complete();
    // }
  }

  fetchOccupation() {
    let URL = '/v2/lead-occupations';
    fetch(URL)
      .then(response => response.json())
      .then((result) => {
        if (result.message !== 'Ok') {
          console.log(result.message);
          return;
        }
        this.setState({ occupationList: result.data });
      });
  }

  fetchAreaUid() {
    let URL = `/v1/city-areas?cityUid=${this.props.data.cityUid}`;
    fetch(URL)
      .then(response => response.json())
      .then((result) => {
        if (result.message !== 'Ok') {
          console.log(result.message);
          return;
        }
        this.setState({ areaUidList: result.data });
      });
  }

  fetchPartyDetails = () => {
    let URL = `/v2/lease/parties?leaseUid=${this.props.match.params.id}`;
    fetch(URL)
      .then(response => response.json())
      .then((result) => {
        if (result.message !== 'Ok') {
          console.log(result.message);
          return;
        }
        let tenant = {};
        let owner = {};
        if (result.data.length > 0) {
          for (let i = 0; i < result.data.length; i++) {
            if (result.data[i].partyType === "Tenant") {
              tenant = result.data[i];
            } else if (result.data[i].partyType === "Landlord") {
              owner = result.data[i];
            }
          }
          let values = { ...this.state.values };
          values.owner = owner;
          values.tenant = tenant;
          this.setState({
            loaded: true,
            values
          }, this.props.updateValues(this.state.values));
        } else {
          console.log("no data found");
        }
        this.setState({ loaded: true }, this.props.updateValues(this.state.values))
      });
  }

  fetchPropertyDetails = () => {
    let URL = `/v2/lease/properties?leaseUid=${this.props.match.params.id}`;
    fetch(URL)
      .then(response => response.json())
      .then((result) => {
        if (result.message !== 'Ok') {
          console.log(result.message);
          return;
        }
        if (result.data.length > 0) {
          let values = { ...this.state.values };
          values.property = result.data[0];
          console.log(values);
          this.setState({
            loaded: true,
            values
          }, this.props.updateValues(this.state.values));
        } else {
          console.log("no data found");
        }
        this.setState({ loaded: true }, this.props.updateValues(this.state.values))
      });

  }

  textInputChange = (event) => {
    let values = this.state.values;
    const { id, value } = event.target;
    const idArr = id.split('-');
    if (idArr.length > 1) {
      values[idArr[0]][idArr[1]] = value;
    } else {
      values[id] = value;
    }
    this.setState({ values }, this.props.updateValues(this.state.values));
  }

  otherInputChange = (value, id) => {
    let values = this.state.values;
    const idArr = id.split('-');
    if (idArr.length > 1) {
      values[idArr[0]][idArr[1]] = value;
    } else {
      values[id] = value;
    }
    this.setState({ values }, this.props.updateValues(this.state.values));
  }

  validateForm = () => {
    const validateFields = this.state.formValidate;
    let formErrorMsg = {};
    for (const key in validateFields) {
      let keySplit = key.split("-");
      let value = keySplit.length > 1 ? this.state.values[keySplit[0]][keySplit[1]] : this.state.values[keySplit[0]]
      if (validateFields[key].indexOf("required") > -1 && !value) {
        formErrorMsg[key] = "This field is required";
      } else if (validateFields[key].indexOf("mobile") > -1 && !numberUtils.isMobile(value)) {
        formErrorMsg[key] = "Must be a valid mobile number";
      } else if (validateFields[key].indexOf("pin") > -1 && !numberUtils.isPincode(value)) {
        formErrorMsg[key] = "Must be a valid pincode";
      } else if (validateFields[key].indexOf("pan") > -1 && !numberUtils.isPAN(value)) {
        formErrorMsg[key] = "Must be a valid PAN Number";
      }
    }
    this.setState({ formErrorMsg })
    return Object.keys(formErrorMsg).length;
  }

  updateParty = () => {
    const invalidFields = this.validateForm();
    if (invalidFields > 0) return;
    const createURL = '/v2/lease/party/create';
    // const updateURL = '/v2/lease/party/update';
    const updateURL = '/v2/lease/party/create';
    let ownerData = {
      ...this.state.values.owner,
      leaseUid: this.props.leaseUid,
      partyType: 'Landlord',
      aadhaarNumber: '123456789101',
    }
    let tenantData = {
      ...this.state.values.tenant,
      leaseUid: this.props.leaseUid,
      partyType: 'Tenant',
      aadhaarNumber: '123456789101',
    }

    let propertyData = {
      ...this.state.values.property,
      leaseUid: this.props.leaseUid,
    }

    let ownerURL = ownerData.uid ? updateURL : createURL;
    let tenantURL = tenantData.uid ? updateURL : createURL;
    // let propertyURL = propertyData.uid ? '/v2/lease/property/update' : '/v2/lease/property/create';
    let propertyURL = propertyData.uid ? '/v2/lease/property/create' : '/v2/lease/property/create';

    fetch(ownerURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(ownerData)
    })
      .then(response => response.json())
      .then((result) => {
        if (result.message === 'Ok') {
          this.setState({ ownerPost: true }, () => {
            if (this.state.ownerPost && this.state.tenantPost && this.state.propertyPost) {
              this.props.complete();
            }
          });
        }
      });
    fetch(tenantURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(tenantData)
    })
      .then(response => response.json())
      .then((result) => {
        if (result.message === 'Ok') {
          this.setState({ tenantPost: true }, () => {
            if (this.state.ownerPost && this.state.tenantPost && this.state.propertyPost) {
              this.props.complete();
            }
          });
        }
      });
    fetch(propertyURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(propertyData)
    })
      .then(response => response.json())
      .then((result) => {
        if (result.message === 'Ok') {
          this.setState({ propertyPost: true }, () => {
            if (this.state.ownerPost && this.state.tenantPost && this.state.propertyPost) {
              this.props.complete();
            }
          });
        }
      });
  }

  render() {
    return (
      <div className="details-form">
        {
          this.state.loaded ?
            <div className="" style={{ marginLeft: 0 }}>
              <Card className="card" elevation={Elevation.ONE}>
                <div className="columns is-multiline is-variable is-3 rent-details">
                  <div className="column is-12 col-thin-ex">
                    <p className="is-size-6 has-text-grey">Owner {(this.props.data.createdBy === "Landlord") && "(You)"}</p>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["owner-name"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.owner.name} large id="owner-name" placeholder="Name" type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["owner-age"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.owner.age} large id="owner-age" placeholder="Age" type="number" />
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["owner-gender"]}
                      intent="warning"
                    >
                      <HTMLSelect
                        id="owner-gender"
                        className="wide-select"
                        fill
                        large
                        onChange={this.textInputChange}
                        value={this.state.values.owner.gender || 0}
                      >
                        <option value={0} disabled>Select Gender</option>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                      </HTMLSelect>
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup>
                      <HTMLSelect
                        id="owner-occupation"
                        className="wide-select"
                        fill
                        large
                        onChange={this.textInputChange}
                        value={this.state.values.owner.occupation || 0}
                      >
                        <option value={0} disabled>Select Occupation</option>
                        {this.state.occupationList.map(item => (
                          <option value={item.uid} key={item.uid}>{item.name}</option>
                        ))}
                      </HTMLSelect>
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["owner-mobile"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.owner.mobile} large id="owner-mobile" placeholder="Mobile" type="number" />
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup>
                      <InputGroup onChange={this.textInputChange} value={this.state.values.owner.email} large id="owner-email" placeholder="Email" type="email" />
                    </FormGroup>
                  </div>
                  <div className="column is-12 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["owner-panNumber"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.owner.panNumber} maxLength="11" large id="owner-panNumber" placeholder="PAN Number" type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-12 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["owner-permanentAddress"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.owner.permanentAddress} large id="owner-permanentAddress" placeholder="Permanent Address" type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-12 col-thin-ex">
                    <p className="is-size-6 has-text-grey">Tenant {(this.props.data.createdBy === "Tenant") && "(You)"}</p>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["tenant-name"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.tenant.name} large id="tenant-name" placeholder="Name" type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["tenant-age"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.tenant.age} large id="tenant-age" placeholder="Age" type="number" />
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["tenant-gender"]}
                      intent="warning"
                    >
                      <HTMLSelect
                        id="tenant-gender"
                        className="wide-select"
                        fill
                        large
                        onChange={this.textInputChange}
                        value={this.state.values.tenant.gender || 0}
                      >
                        <option value={0} disabled>Select Gender</option>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                      </HTMLSelect>
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup>
                      <HTMLSelect
                        id="tenant-occupation"
                        className="wide-select"
                        fill
                        large
                        onChange={this.textInputChange}
                        value={this.state.values.tenant.occupation || 0}
                      >
                        <option value={0} disabled>Select Occupation</option>
                        {this.state.occupationList.map(item => (
                          <option value={item.uid} key={item.uid}>{item.name}</option>
                        ))}
                      </HTMLSelect>
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["tenant-mobile"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.tenant.mobile} large id="tenant-mobile" placeholder="Mobile" type="number" />
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup>
                      <InputGroup onChange={this.textInputChange} value={this.state.values.tenant.email} large id="tenant-email" placeholder="Email" type="email" />
                    </FormGroup>
                  </div>
                  <div className="column is-12 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["tenant-panNumber"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.tenant.panNumber} maxLength="11" large id="tenant-panNumber" placeholder="PAN Number" type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-12 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["owner-permanentAddress"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.tenant.permanentAddress} large id="tenant-permanentAddress" placeholder="Permanent Address" type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-12 col-thin-ex">
                    <p className="is-size-6 has-text-grey">Rented Property</p>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["property-areaUid"]}
                      intent="warning"
                    >
                      <HTMLSelect
                        id="property-areaUid"
                        className="wide-select"
                        fill
                        large
                        onChange={this.textInputChange}
                        value={this.state.values.property.areaUid || 0}
                      >
                        <option value={0} disabled>Select Area</option>
                        {this.state.areaUidList.map(item => (
                          <option value={item.uid} key={item.uid}>{item.name}</option>
                        ))}
                      </HTMLSelect>
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["property-propertyType"]}
                      intent="warning"
                    >
                      <HTMLSelect
                        id="property-propertyType"
                        className="wide-select"
                        fill
                        large
                        onChange={this.textInputChange}
                        value={this.state.values.property.propertyType || 0}
                      >
                        <option value={0} disabled>Select Property Type</option>
                        <option value="Flat">Flat</option>
                        <option value="Bungalow">Bungalow</option>
                        <option value="Shop">Shop</option>
                        <option value="Rowhouse">Rowhouse</option>
                      </HTMLSelect>
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["property-builtupArea"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.property.builtupArea} large id="property-builtupArea" placeholder="Built-up Area" type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup>
                      <InputGroup onChange={this.textInputChange} value={this.state.values.property.bedroomCount} large id="property-bedroomCount" placeholder="Number of Bedrooms" type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup>
                      <InputGroup onChange={this.textInputChange} value={this.state.values.property.bathroomCount} large id="property-bathroomCount" placeholder="Number of Bathrooms" type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup>
                      <InputGroup onChange={this.textInputChange} value={this.state.values.property.propertyNumber} maxLength="15" large id="property-propertyNumber" placeholder="Property No." type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup>
                      <InputGroup onChange={this.textInputChange} value={this.state.values.property.floorNumber} large id="property-floorNumber" placeholder="Floor No." type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-6 col-thin-ex">
                    <FormGroup
                      helperText={this.state.formErrorMsg["property-pincode"]}
                      intent="warning"
                    >
                      <InputGroup onChange={this.textInputChange} value={this.state.values.property.pincode} large id="property-pincode" placeholder="Pincode" type="number" />
                    </FormGroup>
                  </div>
                  <div className="column is-12 col-thin-ex">
                    <FormGroup>
                      <InputGroup onChange={this.textInputChange} value={this.state.values.property.buildingName} maxLength="250" large id="property-buildingName" placeholder="Address" type="text" />
                    </FormGroup>
                  </div>
                  <div className="column is-12 col-thin-ex">
                    <FormGroup>
                      <TextArea onChange={this.textInputChange} value={this.state.values.property.furnitureAndFixtures} large id="property-furnitureAndFixtures" placeholder="Furniture and Fixtures" type="text" />
                    </FormGroup>
                  </div>
                </div>
              </Card>
              <div className="btn-block">
                <Button
                  intent="primary"
                  text="Submit"
                  onClick={this.updateParty}
                  fill
                  large
                />
              </div>
            </div> : null
        }
      </div>
    );
  }
}

export default withRouter(PartyDetails);


// WEBPACK FOOTER //
// ./src/app/components/rent-agreement-details/party-details.js